module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-litho-finish-limestone-clay.14037fe6.jpg";